var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _path, _path2, _rect3, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _rect4, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _rect5, _text21, _rect6, _text22, _rect7, _text23, _rect8, _text24, _rect9, _text25, _rect10, _text26, _text27, _text28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase1Fig2MonkeypatchTwoGraders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One submission, two graders")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The same cheating submission runs against both graders, and CI asserts both verdicts on every run.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 640,
    height: 92,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 128,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "SUBMISSION")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 152,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "does no work, monkeypatches ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "sys.modules"), " to overwrite")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 172,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "the answer key")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 192 L600 214 L318 214 L318 238",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600 214 L882 214 L882 238",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 240,
    width: 540,
    height: 228,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 272,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "NAIVE GRADER, IN PROCESS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 298,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "imports the submission into its own interpreter,")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 318,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "the patched answer key looks correct from inside,")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 338,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "so the cheat grades clean")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 382,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "VERDICT")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 416,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 28,
    fontWeight: 700,
    fill: "#DC2626"
  }, "ACCEPTED AND PAID")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 442,
    fontSize: 12,
    fill: "#6B7F74"
  }, "paying a cheating submission is the failure")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 612,
    y: 240,
    width: 540,
    height: 228,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 272,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "PROCESS-ISOLATED GRADER")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 298,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "grades in a fresh subprocess with its own interpreter,")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 318,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "the submission cannot reach the grader's answer key,")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 338,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "the monkeypatch lands on nothing")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 382,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "VERDICT")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 416,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 28,
    fontWeight: 700,
    fill: "#16A34A"
  }, "REJECTED")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 442,
    fontSize: 12,
    fill: "#6B7F74"
  }, "the correct outcome, asserted in CI")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 512,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "ATTACK FIXTURES HELD IN THE SUITE")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 526,
    width: 54,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "weak")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 526,
    width: 77,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 154.5,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "overfit")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 526,
    width: 92,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 253,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "injection")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 526,
    width: 39,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 332.5,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "eq")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 526,
    width: 54,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 393,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "exit")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 526,
    width: 107,
    height: 30,
    rx: 8,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 487.5,
    y: 546,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "monkeypatch")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 546,
    fontSize: 12,
    fill: "#6B7F74"
  }, "six attacks, every grader change replays all six")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 606,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Both verdicts are pinned in CI, any regression that lets the monkeypatch get paid again turns the build red.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase1Fig2MonkeypatchTwoGraders);
export default __webpack_public_path__ + "static/media/case1-fig2-monkeypatch-two-graders.03615fd80acff4fcc0bcebd6a33b35d1.svg";
export { ForwardRef as ReactComponent };